import { Directive } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DirectMessageComponent } from './direct-message.component';
@Directive({
  selector: '[appWithDirectMessage]',
  inputs: ["from", "to"],
  host: {
    "(click)": "openDialog()"
  }
})
export class WithDirectMessageDirective {
  public from: any;
  public to: any;
  constructor(public dialog: MatDialog) {

  }

  openDialog(): void {
    this.dialog.open(DirectMessageComponent, {
      width: '400px',
      data: { from: this.from, to: this.to }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/direct-message/with-direct-message.directive.ts